/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Google_UnavailableInputs */

const cs_settings_calendar_google_unavailable = /** @type {(inputs: Settings_Calendar_Google_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojení Google zatím není dostupné. Požádejte správce, aby na serveru nastavil Google kalendář pro produkt. Do té doby můžete používat iCal níže.`)
};

const en_settings_calendar_google_unavailable = /** @type {(inputs: Settings_Calendar_Google_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google calendar connect is not available yet. Ask an admin to enable Google calendar for this product on the server. Until then you can use iCal below.`)
};

/**
* | output |
* | --- |
* | "Google calendar connect is not available yet. Ask an admin to enable Google calendar for this product on the server. Until then you can use iCal below." |
*
* @param {Settings_Calendar_Google_UnavailableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_google_unavailable = /** @type {((inputs?: Settings_Calendar_Google_UnavailableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Google_UnavailableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_google_unavailable(inputs)
	return cs_settings_calendar_google_unavailable(inputs)
});